import classNames from 'classnames';
import * as React from 'react';

interface Props {
    className?: string;
    children?: React.ReactNode;
}

export default function PageStaticSection({ className = undefined, children = undefined }: Props) {
    return <section className={classNames('page_static-section', className)}>{children}</section>;
}
